export enum actionType {
    DEFAULT_STATE='DEFAULT_STATE',
    CHANGE_LANGUAGE='CHANGE_LANGUAGE',
    UPDATE_LANGUAGE='UPDATE_LANGUAGE',
    RESET_IS_LANGUAGE_CHANGED='RESET_IS_LANGUAGE_CHANGED',
    PAGE_LIMIT_UPDATED='PAGE_LIMIT_UPDATED',
    GET_PAGE_LIMIT='GET_PAGE_LIMIT',
    RESET_PAGE_LIMIT='RESET_PAGE_LIMIT'
  }

export interface IActionType {
    type: any
}

export interface IActionTypePayload {
    type: any,
    payload:any
}